var _defs, _path, _path2, _path3, _path4, _line, _line2, _circle, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowMonthlySubscriptioncopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.55 448.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#f26725;stroke-linecap:round;stroke-linejoin:round;stroke-width:10.87px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m381.45,246.75c-1.26,24.89-9.94,48.01-24.06,67.55-8.67,11.69-15.47,24.57-20.09,38.16-4.62,13.59-7.07,27.9-7.07,42.46h-55.13l-2.63-22.07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m176.7,372.85l-3.64,22.07h-63.34l1.97-29.93c2.48-37.65-24.38-70.89-61.69-76.38l-7.67-1.13v-65.63l9.19-2.29c18.18-4.54,33.62-16.5,42.57-32.97l10.21-18.79c2.86-5.26,2.35-11.7-1.29-16.45l-31.6-41.3,11.45-5.38c21.33-10.04,46.16-7.43,64.8,6.15,3.84,2.79,7.27,6.13,10.39,9.72l3.3,3.8c9.21-4.9,19.05-8.91,29.38-11.89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m166.3,351.03h0c40.26,10.41,82.51,10.41,122.77,0h0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m282.33,186.32c5.36,7,14.79,11.65,25.53,11.65,16.68,0,30.2-11.21,30.2-25.04,0-13.1-12.16-23.42-27.58-24.95h.02c-14.02-1.01-25.03-10.76-25.03-22.65,0-12.56,12.28-22.73,27.42-22.73,9.62,0,18.08,4.11,22.97,10.32"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 310.2,
    y1: 199.03,
    x2: 310.2,
    y2: 216.74
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 310.2,
    y1: 82.57,
    x2: 310.2,
    y2: 101.04
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 310.2,
    cy: 149.66,
    r: 96.03,
    transform: "translate(-14.97 263.18) rotate(-45)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 141.26,
    y1: 184.22,
    x2: 141.26,
    y2: 197.97
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowMonthlySubscriptioncopy2);
export default __webpack_public_path__ + "static/media/Low Monthly Subscription copy 2.f52acc6a0417c7fa132fc32212937941.svg";
export { ForwardRef as ReactComponent };